<template>
        <div class="wrapper-invoicelist">
            <div class="invoicelist">
                Invoices

            </div>
        </div>

</template>

<script>
export default {

  name: 'List',

  computed: {

  },

  methods: {
  }
}
</script>
